module.exports = __webpack_public_path__ + "assets/img/yyindex-9.358e3cdb.png";